import React from "react";
import { Bell, Heart, MessageCircle, UserPlus, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { timeAgo } from "@/lib/time";

const ICONS = { like: Heart, comment: MessageCircle, follow: UserPlus, message: Mail };
const BG = { like: "bg-primary text-primary-foreground", comment: "bg-sage", follow: "bg-accent", message: "bg-secondary" };

const labelFor = (n) => {
  const name = n.actor_name || "Someone";
  if (n.type === "like") return `${name} liked your post`;
  if (n.type === "comment") return `${name} commented${n.extra ? `: "${n.extra}"` : ""}`;
  if (n.type === "follow") return `${name} started following you`;
  if (n.type === "message") return `${name} sent you a message${n.extra ? `: "${n.extra}"` : ""}`;
  return `${name}: ${n.type}`;
};

const linkFor = (n) => {
  if (n.type === "message" && n.actor_id) return `/messages/${n.actor_id}`;
  if (n.type === "follow" && n.actor_id) return `/profile/${n.actor_id}`;
  return null;
};

export const NotificationItem = ({ n, onNavigate }) => {
  const Icon = ICONS[n.type] || Bell;
  const inner = (
    <div className={`brutal-card p-3 ${BG[n.type] || "bg-card"} flex items-start gap-3`}>
      <div className="w-8 h-8 rounded-full border-2 border-foreground bg-card overflow-hidden flex items-center justify-center flex-shrink-0">
        {n.actor_avatar ? <img src={fileUrl(n.actor_avatar)} alt="" className="w-full h-full object-cover" /> : <Icon size={14} strokeWidth={2.5} />}
      </div>
      <div className="flex-1 text-sm min-w-0">
        <div className="leading-snug">{labelFor(n)}</div>
        <div className="text-xs opacity-70 mt-0.5">{timeAgo(n.created_at)}</div>
      </div>
    </div>
  );
  const to = linkFor(n);
  if (to) return <Link to={to} onClick={onNavigate} data-testid={`notif-${n.id}`}>{inner}</Link>;
  return <div data-testid={`notif-${n.id}`}>{inner}</div>;
};
